import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ShopsService, RootService } from 'src/app/services';
import { Router } from '@angular/router';
import { removeEmptyQuery, sleep } from 'src/app/helpers';

import {CreateStoresComponent} from '../../shared/stores';

@Component({
  selector: 'app-shops',
  templateUrl: './shops.component.html',
  styleUrls: ['./shops.component.scss']
})
export class ShopsComponent implements OnInit, OnDestroy {
  constructor(
    private shopService: ShopsService,
    private rootService: RootService,
    private notification: NzNotificationService,
    private route: Router,
  ) { }

  unsubscribe$ = new Subject<void>();
  isAdmin  = false;
  page = 1;
  pageSize = 10;
  data = [];
  // @ts-ignore
  @ViewChild('importShop') importShop;
  @ViewChild(CreateStoresComponent , {static: true}) createStoreComponent;

  // ================================list==================================//
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  total: number;
  loading: Boolean = true;
  listOfDisplayData: any[] = [];
  listOfAllData: any[] = [];
  mapOfCheckedId: { [key: string]: boolean } = {};
  ids: any[] = [];
  isShow: Boolean;

  // ============================search=============================//
  keyword: string;
  province_id: number;
  province_new_id: number;
  type_id: number;
  cities: any[] = [];
  cities1: any[] = [];
  shopTypes: any[] = [];

  delayTimer: any;

  /*Check link image error*/
  imageFalse: any[] = [];

  dataDelete = {
    label: 'Xác nhận xóa điểm bán',
    value: '<p>Bạn có chắc chắn muốn xoá điểm bán?</p>'
  };

  // ===============================actions=================================//
  @ViewChild('addStores', { static: true }) addStores;
  @ViewChild('createStores', { static: true }) createStores;
  @ViewChild('updateStores', { static: true }) updateStores;
  @ViewChild('deleteStores', { static: true }) deleteStores;
  action: any;



  openMessage(type: string, title: string, content: any) {
    return this.notification.create(
      type,
      title,
      content
    );
  }

  currentPageDataChange($event: any[]): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }

  refreshStatus(data?): void {
    console.log(data)
    if (data) {
      const index = this.data.findIndex(z => z.id === data.id);
      index === -1 ? this.data.push({shopName: data.shopName, phoneNumber: data.phoneNumber}) : this.data.splice(index, 1);
    }
    this.isAllDisplayDataChecked = this.listOfDisplayData.every(item => this.mapOfCheckedId[item.id]);
    this.isIndeterminate = this.listOfDisplayData.some(item => this.mapOfCheckedId[item.id]) && !this.isAllDisplayDataChecked;
    this.ids = [];
    for (const [key, value] of Object.entries(this.mapOfCheckedId)) {
      if (value) {
        this.ids.push(key);
      }
    }
    if (this.ids.length > 0) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(item => (this.mapOfCheckedId[item.id] = value));
    this.refreshStatus();
    this.data = this.listOfDisplayData.map(z => {
      return {phoneNumber: z.phoneNumber, shopName: z.shopName};
    });
  }

  ngOnInit() {
    this.notification.config({
      nzPlacement: 'bottomRight'
    });

    this.loadCities();
    this.loadCities1();
    this.loadShopType();
    this.loadData();
    const user = localStorage.getItem('currentUser');
    // @ts-ignore
    this.isAdmin = JSON.parse(user).isAdmin;
  }
  search() {
    clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(() => {
      this.page = 1;
      this.loadData();
    }, 300);
  }

  filterCities($event: number) {
    this.province_id = $event;
    this.page = 1;
    this.loadData();
  }

  filterCities1($event: number) {
    this.province_new_id = $event;
    this.page = 1;
    this.loadData();
  }

  filterShopType($event: number) {
    this.type_id = $event;
    this.page = 1;
    this.loadData();
  }

  loadCities1() {
    this.rootService.getLocationNew({type: 1}).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res: any) => {
        this.cities1 = res.data.data;
      },
      (err) => {
        this.openMessage('error', 'Lỗi !!!', `${err}`);
        return;
      },
    );
  }

  loadCities() {
    this.rootService.listCities().pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res: any) => {
        this.cities = res.data.items;
      },
      (err) => {
        this.openMessage('error', 'Lỗi !!!', `${err}`);
        return;
      },
    );
  }

  loadShopType() {
    this.shopService.getAllType().pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res: any) => {
        this.shopTypes = res.data.items;
      },
      (err) => {
        this.openMessage('error', 'Lỗi !!!', `${err}`);
        return;
      },
    );
  }

  sleep(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async loadData(ms = 0) {
    const query: any = {
      keyword: this.keyword ? this.keyword.trim() : null,
      province_id: this.province_id,
      province_new_id: this.province_new_id,
      type_id: this.type_id,
      page: this.page,
      page_size: this.pageSize,
    };

    removeEmptyQuery(query);
    await sleep(ms);

    this.loading = true;
    this.shopService.getAll(query).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res) => {
        this.loading = false;
        this.total = res.data.totalElement;
        this.listOfAllData = res.data.items;
        if (!res.data.items && this.page > 1) {
          this.page = this.page - 1;
          this.loadData();
          return;
        }
      },
      (err) => {
        this.openMessage('error', 'Lỗi !!!', `${err}`);
        return;
      }
    );
  }

  resetData() {
    this.keyword = null;
    this.province_id = null;
    this.province_new_id = null;
    this.type_id = null;
    this.page = 1;
    this.loadData();
  }
  checkImageErr(imageError: any) {
    this.imageFalse.push(imageError);
  }

  showImage(id: any, imageLink: any) {
    if (!this.imageFalse.includes(id)) {
      window.open(imageLink, '_blank');
    }
  }

  // router
  router(data: any) {
    const body: any = {
      shop_type: data.shop_type,
      is_owner: data.is_owner,
    };
    this.shopService.getShopType(body);

    // this.route.navigate([`business/shops/detail/${data.id}&shopName=${data.shopName}&phoneNumber=${data.phoneNumber}`]);
    this.route.navigate([`business/shops/detail`,  {id: data.id, shopName: data.shopName, phoneNumber: data.phoneNumber}]);
  }

  exportExcel() {
    const query: any = {
      export_all: this.ids.length === 0,
      keyword: this.keyword ? this.keyword.trim() : null,
      province_id: this.province_id,
      type_id: this.type_id,
      ids: this.ids ? this.ids.toString() : null
    };

    removeEmptyQuery(query);
    this.shopService.exportExcel(query).pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {

      this.rootService.export(data, 'Danh sách điểm bán.xlsx');
    });
  }
  importExcel() {
    this.importShop.showModal();
  }
  handleImportShopExcel(body) {
    const file = body.file;
    const query = {
      rule: body.param
    };
    if (file === undefined) {
      this.notification.error(
        'Có lỗi xảy ra',
        'Chưa chọn file'
      );
      this.importShop.cancelLoading();
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    this.shopService.importExcel(query, formData).pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        this.importShop.cancelLoading();
        if (res.code === 1) {

          this.notification.success(
            'Thành công',
            'Thêm mới cửa hàng thành công'
          );
          this.importShop.handleCancel();
          this.loadData(500);
          return;
        }


        this.notification.error(
          'Thêm mới cửa hàng thất bại',
          res.message
        );
      },
      error => {


        this.importShop.cancelLoading();
        this.notification.error(
          'Thêm mới cửa hàng thất bại',
          error.message
        );
      }
    );
  }
  // ==============================output====================================//
  add(data: any) {
    const body: any = {
      type_id: data.type_id,
      product_ids: data.product_ids
    };
    this.shopService.add(data.id, body).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res) => {
        this.addStores.success();
        if (res.code === 1) {


          this.openMessage('success', 'Thành công', 'Thêm sản phẩm thành công');
          this.addStores.handleCancel();
          this.loadData(500);
          return;
        }
        if (res.code !== 1) {


          this.openMessage('warning', 'Cảnh báo', `${res.message}`);
          return;
        }
      },
      (err) => {

        this.openMessage('error', 'Lỗi !!!', `${err}`);
        this.addStores.success();
        return;
      },
    );
  }

  create(body: any) {
    this.shopService.create(body).pipe(takeUntil(this.unsubscribe$)).subscribe(
      async (res) => {
        this.createStores.success();
        this.createStoreComponent.address1 = '';
        if (res.code === 1) {

          this.createStoreComponent.isDisable = true;
          this.createStoreComponent.isLoadingBtn = true;
          this.createStoreComponent.isVisible = true;

          this.notification.create(
            'success',
            'Thành công',
            'Tạo cửa hàng thành công'
          );

          await this.loadData(1000);
          setTimeout(() => {
            this.createStores.handleCancel();
          }, 1000);
          return;
        }
        if (res.code !== 1) {
          this.createStoreComponent.isDisable = false;
          this.createStoreComponent.isLoadingBtn = false;


          this.openMessage('warning', 'Cảnh báo', `${res.message}`);
          return;
        }
      },
      (err) => {
        this.createStoreComponent.isDisable = false;
        this.createStoreComponent.isLoadingBtn = false;

        this.openMessage('error', 'Lỗi !!!', `${err}`);
        this.createStores.success();
        return;
      },
    );
  }

  update(body: any) {
    const formValue = body.body;
    this.shopService.update(body.shopId, formValue).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res) => {
        if (res.code === 1) {


          this.updateStores.isDisable = true;
          this.updateStores.isLoadingBtn = true;
          this.updateStores.isVisible = false;

          this.openMessage('success', 'Thành công', 'Cập nhật cửa hàng thành công');

          setTimeout(() => {
            this.updateStores.handleCancel();
          }, 1000);
          return;
        }
        if (res.code !== 1) {

          this.updateStores.isDisable = false;
          this.updateStores.isLoadingBtn = false;
          this.openMessage('warning', 'Cảnh báo', `${res.message}`);
          return;
        }
      },
      (err) => {

        this.createStoreComponent.isDisable = false;
        this.createStoreComponent.isLoadingBtn = false;
        this.openMessage('error', 'Lỗi !!!', `${err}`);
        this.updateStores.success();
        return;
      },
    );
  }
  delete(id: any) {
    const body = {
      body: {
        shop_ids: id,
      },
    };
    this.shopService.destroy(body).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res) => {
        this.deleteStores.success();
        if (res.code === 1) {



          this.mapOfCheckedId = {};
          this.openMessage('success', 'Thành công', 'Xóa cửa hàng thành công');
          this.deleteStores.handleCancel();
          this.loadData(500);
        }
        if (res.code === 103) {


          this.openMessage('warning', 'Cảnh báo', `Doanh nghiệp không có quyền thực hiện tính năng này`);
          return;
        }
        if (res.code !== 1) {


          this.openMessage('warning', 'Cảnh báo', `${res.message}`);
        }
      },
      (err) => {


        this.openMessage('error', 'Lỗi !!!', `${err}`);
        this.deleteStores.success();
        return;
      },
    );
  }
  actionsButton() {
    if (this.action == 1) {
      this.createStores.showModal('createShop');
    } else if (this.action == 2) {
      this.deleteStores.showModal(this.dataDelete, this.ids);
    } else if (this.action == 3) {
      this.exportExcel();
    }
    this.action = null;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
